(function () {

  const BASE_URL = window.getAPIUrl("baseUrl");
  const API_KEY = window.getAPIUrl("key");

  const PER_PAGE = 9;
  const MOBILE_BREAKPOINT = 991;

  const SELECTORS = {
    form: '[data-dealer-locator-form]',
    input: '[data-dealer-locator-input]',
    category: '[data-dealer-locator-category]',
    submit: '[data-dealer-locator-submit]',
    defaultState: '[data-dealer-locator-default]',
    results: '[data-dealer-locator-results]',
    grid: '[data-dealer-locator-grid]',
    pagination: '[data-dealer-locator-pagination]',
    paginationLoader: '[data-dealer-locator-pagination-loader]',
    sentinel: '[data-dealer-locator-sentinel]',
    empty: '[data-dealer-locator-empty]',
    loading: '[data-dealer-locator-loading]',
  };

  const REVEAL_CLASS = 'dealer-locator__grid--reveal';
  const REVEAL_DURATION_MS = 550;

  function escapeHtml(str) {
    if (!str) return '';
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function getDirectionsUrl(address) {
    if (!address) return '#';
    return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(address)}`;
  }

  function renderCard(dealer) {

    // NEW API FIELD MAPPING
    const name = dealer.name || '';
    const address = dealer.retailerAddress || '';
    const phone = dealer.retailerMobile || '';
    const pincode = dealer.pincode || '';

    const shareText = [
      name,
      address,
      phone,
      pincode ? 'Pincode: ' + pincode : ''
    ].filter(Boolean).join('\n');

    const pincodeHtml = pincode
      ? `<div class="dealer-locator__card-address"><p>
         <span class="dealer-locator__card-pincode-label">Pincode: </span>
         <span class="dealer-locator__card-pincode-value">${escapeHtml(pincode)}</span>
       </p></div>`
      : '';

    const phoneHtml = phone
      ? `<p class="dealer-locator__card-phone">
         <a href="tel:${escapeHtml(phone.replace(/\s/g, ''))}" class="link">
           <span class="icon-wrap">
             <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_577_316)">
              <path d="M15.4116 13.6256C15.5154 13.5565 15.6349 13.5144 15.7591 13.5031C15.8834 13.4918 16.0085 13.5117 16.1231 13.5609L20.5444 15.5419C20.6934 15.6055 20.8177 15.7158 20.8989 15.856C20.98 15.9963 21.0135 16.1591 20.9944 16.32C20.8487 17.4085 20.3127 18.407 19.486 19.1299C18.6593 19.8528 17.5982 20.2508 16.5 20.25C13.1185 20.25 9.87548 18.9067 7.48439 16.5156C5.0933 14.1245 3.75 10.8815 3.75 7.49998C3.74916 6.4018 4.1472 5.34068 4.87009 4.51398C5.59298 3.68728 6.59152 3.15126 7.68 3.0056C7.84091 2.98649 8.00368 3.02 8.14395 3.10112C8.28422 3.18224 8.39444 3.30661 8.45813 3.4556L10.4391 7.8806C10.4877 7.99426 10.5076 8.11818 10.4968 8.24134C10.486 8.36451 10.4449 8.48309 10.3772 8.58654L8.37375 10.9687C8.30269 11.076 8.26066 11.1998 8.25179 11.3281C8.24291 11.4565 8.26749 11.5849 8.32313 11.7009C9.09844 13.2881 10.7391 14.909 12.3309 15.6769C12.4475 15.7322 12.5766 15.7563 12.7053 15.7466C12.834 15.7369 12.958 15.6938 13.065 15.6215L15.4116 13.6256Z" stroke="#1C2F76" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </g>
              <defs>
              <clipPath id="clip0_577_316">
              <rect width="24" height="24" fill="white"/>
              </clipPath>
              </defs>
            </svg>
           </span>
           ${escapeHtml(phone)}
         </a>
       </p>`
      : '';

    return `
    <article class="dealer-locator__card color-background-2" role="listitem">
      <div class="dealer-locator__card-top">
        <div class="dealer-locator__card-header">
          <h6 class="dealer-locator__card-title">${escapeHtml(name)}</h6>
          <button type="button"
            class="dealer-locator__share link link--text"
            aria-label="Share"
            data-dealer-share
            data-share-text="${escapeHtml(shareText)}">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_577_214)">
                <path d="M5 12.5C6.38071 12.5 7.5 11.3807 7.5 10C7.5 8.61929 6.38071 7.5 5 7.5C3.61929 7.5 2.5 8.61929 2.5 10C2.5 11.3807 3.61929 12.5 5 12.5Z" stroke="#1C2F76" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M13.75 18.125C15.1307 18.125 16.25 17.0057 16.25 15.625C16.25 14.2443 15.1307 13.125 13.75 13.125C12.3693 13.125 11.25 14.2443 11.25 15.625C11.25 17.0057 12.3693 18.125 13.75 18.125Z" stroke="#1C2F76" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M13.75 6.875C15.1307 6.875 16.25 5.75571 16.25 4.375C16.25 2.99429 15.1307 1.875 13.75 1.875C12.3693 1.875 11.25 2.99429 11.25 4.375C11.25 5.75571 12.3693 6.875 13.75 6.875Z" stroke="#1C2F76" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M11.6469 5.72656L7.10156 8.64844" stroke="#1C2F76" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M7.10156 11.3516L11.6469 14.2734" stroke="#1C2F76" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </g>
            </svg>
          </button>
        </div>

        <div class="dealer-locator__card-address section-rte">
          <p>${escapeHtml(address)}</p>
        </div>

        ${pincodeHtml}
        ${phoneHtml}
      </div>

      <div class="dealer-locator__card-bottom">
        <a href="${getDirectionsUrl(address)}"
          target="_blank"
          class="dealer-locator__card-directions button button--link">
          
          <!-- Directions Icon -->
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_577_322)">
              <path d="M10 7.5C10.6904 7.5 11.25 6.94036 11.25 6.25C11.25 5.55964 10.6904 5 10 5C9.30964 5 8.75 5.55964 8.75 6.25C8.75 6.94036 9.30964 7.5 10 7.5Z" fill="#1C2F76"/>
              <path d="M14.375 6.25C14.375 10.625 10 13.125 10 13.125C10 13.125 5.625 10.625 5.625 6.25C5.625 5.08968 6.08594 3.97688 6.90641 3.15641C7.72688 2.33594 8.83968 1.875 10 1.875C11.1603 1.875 12.2731 2.33594 13.0936 3.15641C13.9141 3.97688 14.375 5.08968 14.375 6.25Z" stroke="#1C2F76" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M15.625 12.1204C17.1656 12.6891 18.125 13.4891 18.125 14.375C18.125 16.1008 14.4875 17.5 10 17.5C5.5125 17.5 1.875 16.1008 1.875 14.375C1.875 13.4891 2.83438 12.6891 4.375 12.1204" stroke="#1C2F76" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </g>
            <defs>
            <clipPath id="clip0_577_322">
              <rect width="20" height="20" fill="white"/>
            </clipPath>
            </defs>
          </svg>
          Get Directions
        </a>
      </div>
    </article>
  `;
  }
  var ARROW_SVG = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.451 4.24896C13.1191 3.91701 12.5809 3.91701 12.249 4.24896C11.917 4.5809 11.917 5.1191 12.249 5.45104L17.7977 10.9998L3.85 10.9998C3.38056 10.9998 3 11.3803 3 11.8498C3 12.3192 3.38056 12.6998 3.85 12.6998L17.7982 12.6998L12.249 18.249C11.917 18.5809 11.917 19.1191 12.249 19.451C12.5809 19.783 13.1191 19.783 13.451 19.451L20.451 12.451C20.5003 12.4018 20.5429 12.3471 20.5782 12.2885C20.6501 12.1691 20.692 12.033 20.699 11.8921C20.6996 11.8781 20.7 11.8641 20.7 11.85C20.7 11.8499 20.7 11.8498 20.7 11.8498C20.7 11.6089 20.5998 11.3914 20.4388 11.2367L13.451 4.24896Z" fill="currentColor"/></svg>';

  /**
   * Compact pagination matching theme `snippets/pagination.liquid` (blog):
   * same classes on <li>/<span>/<button>, ellipsis as <span class="pagination__item">...</span>.
   * Never renders all page numbers (avoids 1…115 wrapping over multiple lines).
   */
  function renderPagination(totalItems, currentPageRaw) {
    const totalPages = Math.max(1, Math.ceil(Number(totalItems) / PER_PAGE));
    if (totalPages <= 1) return '';

    var currentPage = Math.max(1, Math.min(parseInt(currentPageRaw, 10) || 1, totalPages));

    var dotsLi =
      '<li><span class="pagination__item" aria-hidden="true">...</span></li>';

    var renderPageItem = function (page) {
      if (page === currentPage) {
        return (
          '<li><span class="pagination__item pagination__item--current" aria-current="page" aria-label="Page ' +
          page +
          '">' +
          page +
          "</span></li>"
        );
      }
      return (
        '<li><button type="button" class="pagination__item link" aria-label="Page ' +
        page +
        '" data-dealer-page="' +
        page +
        '"><span title="' +
        page +
        '"> ' +
        page +
        "</span></button></li>"
      );
    };

    var list = [];

    if (currentPage > 1) {
      list.push(
        '<li><button type="button" class="pagination__item--prev pagination__item-arrow link motion-reduce" aria-label="Previous page" data-dealer-page="' +
          (currentPage - 1) +
          '">' +
          ARROW_SVG +
          "</button></li>",
      );
    }

    if (totalPages <= 5) {
      for (var i = 1; i <= totalPages; i++) {
        list.push(renderPageItem(i));
      }
    } else if (currentPage <= 3) {
      for (var a = 1; a <= 3; a++) {
        list.push(renderPageItem(a));
      }
      list.push(dotsLi);
      list.push(renderPageItem(totalPages));
    } else if (currentPage >= totalPages - 2) {
      list.push(renderPageItem(1));
      list.push(dotsLi);
      for (var b = totalPages - 2; b <= totalPages; b++) {
        list.push(renderPageItem(b));
      }
    } else {
      list.push(renderPageItem(1));
      list.push(dotsLi);
      list.push(renderPageItem(currentPage - 1));
      list.push(renderPageItem(currentPage));
      list.push(renderPageItem(currentPage + 1));
      list.push(dotsLi);
      list.push(renderPageItem(totalPages));
    }

    if (currentPage < totalPages) {
      list.push(
        '<li><button type="button" class="pagination__item--next pagination__item-arrow link motion-reduce" aria-label="Next page" data-dealer-page="' +
          (currentPage + 1) +
          '">' +
          ARROW_SVG +
          "</button></li>",
      );
    }

    return (
      '<ul class="pagination__list list-unstyled" role="list">' +
      list.join("") +
      "</ul>"
    );
  }

  function updateSubmitState(els) {

    if (!els.input || !els.category || !els.submit) return;

    const inputValue = els.input.value.trim();
    const categoryValue = els.category.value.trim();

    const canSubmit = inputValue !== '' && categoryValue !== '';

    els.submit.disabled = !canSubmit;
    els.submit.setAttribute('aria-disabled', String(!canSubmit));
  }

  function updateUI(els, dealers, loading, currentPage = 1, options = {}) {
    const isInitialResults = options.isInitialResults === true;

    els.loading.hidden = !loading;
    if (loading) {
      if (els.defaultState) els.defaultState.style.display = 'none';
      if (els.results) els.results.hidden = true;
      if (els.empty) els.empty.hidden = true;
      return;
    }

    if (els.defaultState) {
      els.defaultState.style.display = 'none';
    }

    if (!dealers.length) {
      els.results.hidden = true;
      els.empty.hidden = false;
      els.grid.innerHTML = '';
      els.grid.classList.remove(REVEAL_CLASS);
      if (els.pagination) els.pagination.hidden = true;
      return;
    }

    els.results.hidden = false;
    els.empty.hidden = true;

    const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;

    // -------- MOBILE LAZY LOAD --------
    if (isMobile) {

      if (els.pagination) els.pagination.hidden = true;

      const visibleCount = currentPage * PER_PAGE;
      const slice = dealers.slice(0, visibleCount);

      els.grid.innerHTML = slice.map(renderCard).join('');
      if (isInitialResults) {
        els.grid.classList.add(REVEAL_CLASS);
        setTimeout(() => els.grid.classList.remove(REVEAL_CLASS), REVEAL_DURATION_MS);
      } else {
        els.grid.classList.remove(REVEAL_CLASS);
      }

      if (visibleCount < dealers.length && els.sentinel) {

        els.sentinel.hidden = false;

        if (els.observer) els.observer.disconnect();

        els.observer = new IntersectionObserver(entries => {
          if (entries[0].isIntersecting) {
            updateUI(els, dealers, false, currentPage + 1);
          }
        }, { rootMargin: '100px' });

        els.observer.observe(els.sentinel);
      }

      els.currentDealers = dealers;
      return;
    }

    // -------- DESKTOP PAGINATION --------
    const start = (currentPage - 1) * PER_PAGE;
    const paginated = dealers.slice(start, start + PER_PAGE);

    els.grid.innerHTML = paginated.map(renderCard).join('');
    if (isInitialResults) {
      els.grid.classList.add(REVEAL_CLASS);
      setTimeout(() => els.grid.classList.remove(REVEAL_CLASS), REVEAL_DURATION_MS);
    } else {
      els.grid.classList.remove(REVEAL_CLASS);
    }

    if (els.pagination) {
      const html = renderPagination(dealers.length, currentPage);
      if (html) {
        els.pagination.innerHTML = html;
        els.pagination.hidden = false;
      } else {
        els.pagination.hidden = true;
      }
    }

    els.currentDealers = dealers;
    els.currentPage = currentPage;
  }

  function initSection(section) {

    const wrapper = section.querySelector('.dealer-locator');
    const form = wrapper.querySelector(SELECTORS.form);

    const els = {
      input: wrapper.querySelector(SELECTORS.input),
      category: wrapper.querySelector(SELECTORS.category),
      submit: wrapper.querySelector(SELECTORS.submit),
      defaultState: wrapper.querySelector(SELECTORS.defaultState),
      results: wrapper.querySelector(SELECTORS.results),
      grid: wrapper.querySelector(SELECTORS.grid),
      pagination: wrapper.querySelector(SELECTORS.pagination),
      paginationLoader: wrapper.querySelector(SELECTORS.paginationLoader),
      sentinel: wrapper.querySelector(SELECTORS.sentinel),
      empty: wrapper.querySelector(SELECTORS.empty),
      loading: wrapper.querySelector(SELECTORS.loading),
    };

    const getCurrentPosition = () => {
      return new Promise((resolve) => {
        if (!navigator.geolocation) {
          resolve({ lat: null, lng: null });
          return;
        }
        navigator.geolocation.getCurrentPosition(
          (pos) => resolve({ lat: pos.coords.latitude, lng: pos.coords.longitude }),
          () => resolve({ lat: null, lng: null }),
          { timeout: 10000, maximumAge: 60000 }
        );
      });
    };

    updateSubmitState(els);

    if (els.input) {
      els.input.addEventListener('input', () => updateSubmitState(els));
    }

    if (els.category) {
      els.category.addEventListener('change', () => updateSubmitState(els));
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      const pincode = els.input.value.trim();
      const categoryValue = els.category.value.trim();

      if (!pincode || !categoryValue) return;

      updateUI(els, [], true);
      els.submit.setAttribute('aria-busy', 'true');

      getCurrentPosition()
        .then(({ lat, lng }) => {
        const isPincodeNumber = !Number.isNaN(Number(pincode));
          const params = new URLSearchParams({
          ctgry: categoryValue,
          lat: lat,
          lng: lng,
          ...(isPincodeNumber
            ? { pincode: pincode }
            : { city: pincode })
    });

  return fetch(`${BASE_URL}dealer?${params.toString()}`, {
    method: 'POST', // or 'GET' if your API expects GET for query params
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': API_KEY
    }
  });

        })
        .then(res => {
          if (!res.ok) throw new Error(res.status);
          return res.json();
        })
        .then(data => {
          const list = Array.isArray(data.retresp)
            ? data.retresp
            : Array.isArray(data.data)
              ? data.data
              : [];
          updateUI(els, list, false, 1, { isInitialResults: true });
          els.submit.removeAttribute('aria-busy');
        })
        .catch(() => {
          updateUI(els, [], false);
          els.submit.removeAttribute('aria-busy');
        });
    });

    section.addEventListener('click', function (e) {

      const pageBtn = e.target.closest('[data-dealer-page]');
      if (pageBtn) {
        const page = parseInt(pageBtn.getAttribute('data-dealer-page'), 10);
        if (!els.currentDealers || !page) return;

        const showPaginationLoader = () => {
          if (els.paginationLoader) els.paginationLoader.hidden = false;
          requestAnimationFrame(() => {
            updateUI(els, els.currentDealers, false, page);
            requestAnimationFrame(() => {
              setTimeout(() => {
                if (els.paginationLoader) els.paginationLoader.hidden = true;
              }, 300);
            });
          });
        };

        showPaginationLoader();
        wrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }

      const shareBtn = e.target.closest('[data-dealer-share]');
      if (!shareBtn) return;

      const text = shareBtn.getAttribute('data-share-text');

      if (navigator.share) {
        navigator.share({ title: 'Dealer details', text: text }).catch(() => { });
      } else {
        navigator.clipboard.writeText(text);
      }
    });
  }

  function init() {
    document.querySelectorAll('.dealer-locator-section').forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', init);

})();